import { ENV } from 'services/environment/environment';
import { getDocuParseCredentials } from 'services/repositories/docuparse/credentials';
import { DocumentType } from 'support/types';
import { uploadLoader } from 'components/Form/FileInput/Loaders/uploadLoader/uploadLoader';

export const ocrUploadFileLoader = ({
  documentType,
  currentPartnerId,
  sourceDocumentId,
}: {
  documentType: DocumentType | undefined | null;
  currentPartnerId: string | undefined;
  sourceDocumentId: string | undefined;
}) => {
  return async (file: File) => {
    const { access_token } = await getDocuParseCredentials();

    return uploadLoader({
      url: `${ENV.DOCUPARSE_API_URL}api/v1/upload`,
      bearerToken: access_token,
      body: {
        sender_partner_id: currentPartnerId,
        document_type: documentType,
        source_document_id: sourceDocumentId,
      },
    })(file);
  };
};
